import React from 'react';
import { useSelector } from 'react-redux';
import { useLocalize } from '@saviynt/common';
import { Box, Button, Icon } from '@saviynt/design-system';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { MODAL_PAGE_KINDS } from '../../../ModalPageForms/constants';
import { msgs } from '../../constants';

import './SpfRoles.css';

function SpfRoles({ checkoutRoleOnClick, dataTestId, className }) {
  const classes = classnames('SpfRoles', className);
  const localize = useLocalize();

  // JIT for Apps; domain config retrieved from redux
  const { PAM_JIT_FOR_APPS_ENABLED: isJitForApps } = useSelector(
    (state) => state.user.domainInfo || {}
  );

  return (
    <Box className={classes} dataTestId={dataTestId}>
      <Button
        type='button'
        kind={isJitForApps ? 'filled' : 'outlined'}
        leftIcon={
          <Icon
            kind={isJitForApps ? 'CheckOut' : 'PasswordCredentialUnlock'}
            size='smallMedium'
            color='neutral-100'
          />
        }
        onClick={() => checkoutRoleOnClick(MODAL_PAGE_KINDS.COR)}>
        {localize(msgs.pam.sidePanel.checkoutRole)}
      </Button>
    </Box>
  );
}

SpfRoles.propTypes = {
  dataTestId: PropTypes.string,
  checkoutRoleOnClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

SpfRoles.defaultProps = {
  dataTestId: null,
  className: null,
};

export default SpfRoles;
